import { IInfoTile, InfoTileVariant } from '@fdc/types/tiles-model';
import { CoreButton } from '@woolworthslimited/core-components-react/button';
import { CoreIcon } from '@woolworthslimited/core-components-react/icon';
import { CoreLink } from '@woolworthslimited/core-components-react/link';
import { useWindowDimension } from '@woolworthslimited/core-components-react/shared/hooks/useWindowDimension';

import { isSmallDeviceOrGreater } from '@contentservice/shared/services/breakpoint/breakpoint.service';

import { RichText } from '../rich-text/rich-text';

import styles from './info-tile.module.scss';

export const InfoTile = ({
  heading,
  body,
  btnText,
  btnAltText,
  btnClickHandler,
  background,
  variant,
  position,
  graphicUrl,
  iconName,
  isLink = false,
}: IInfoTile) => {
  const [width] = useWindowDimension();
  const isDesktop = isSmallDeviceOrGreater(width);
  let graphic;
  switch (variant) {
    case InfoTileVariant.graphic:
      graphic = graphicUrl && <img src={graphicUrl} alt={''} aria-hidden />;
      break;
    case InfoTileVariant.icon:
      graphic = iconName && <CoreIcon name={iconName} />;
      break;
    case InfoTileVariant.numbered:
      graphic = <div className={styles.position}>{position}</div>;
      break;
    default:
      // none
      graphic = <></>;
      break;
  }

  return (
    <div className={styles.infoTile + ' ' + styles[background]}>
      {graphic}
      <RichText heading={heading} paragraph1={body} />
      {btnText && !isLink && (
        <CoreButton
          label={btnText}
          ariaLabel={btnAltText}
          variant="secondary"
          isFullWidth={!isDesktop}
          clickHandler={btnClickHandler}
        />
      )}
      {btnText && isLink && (
        <CoreLink
          as="button"
          label={btnText}
          restProps={{ 'aria-label': btnAltText }}
          clickHandler={btnClickHandler}
        />
      )}
    </div>
  );
};
